// extracted by mini-css-extract-plugin
module.exports = {"section":"_93444fe79c--section--2x30C","left-column":"_93444fe79c--left-column--32E5k","right-column":"_93444fe79c--right-column--2ocVg"};